// /frontend/src/services/apiCache.js
const cache = new Map();

export const getCache = (key) => {
  const cachedData = cache.get(key);
  if (!cachedData) {
    return null;
  }

  const isExpired =
    new Date().getTime() - cachedData.timestamp > cachedData.duration;
  if (isExpired) {
    cache.delete(key);
    return null;
  }

  return cachedData.data;
};

export const setCache = (key, data, duration) => {
  const timestamp = new Date().getTime();
  cache.set(key, { data, timestamp, duration });
};
